import React from 'react'

import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { icon } from 'constant'

import classNames from '@nexys/components/ContactMe/ContactMe.module.scss'

function ContactMe() {
  const { xs } = useBreakpoint()
  const token =
    typeof window !== 'undefined' ? localStorage.getItem('access_token') : ''

  return (
    <div
      style={{
        position: 'fixed',
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: token ? 'flex' : 'none',
        alignItems: 'flex-end',
        cursor: 'pointer',
        marginRight: '20px',
        marginBottom: '40px',
        justifyContent: 'flex-end',
      }}
      className={classNames.parent}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          className={classNames.wrapText}
          style={{ marginBottom: xs ? '100px' : '10px' }}
        >
          <a
            target="_blank"
            href="https://api.whatsapp.com/send?phone=6285713082022"
            rel="noopener noreferrer"
          >
            <img src={icon.ICS} alt="" style={{ width: '16px' }} />
            <span className={classNames.cs}>Customer Service</span>
          </a>
        </div>
        <div
          className={classNames.wrapText}
          style={{ marginBottom: xs ? '100px' : '10px' }}
        >
          <a
            target="_blank"
            href="https://api.whatsapp.com/send?phone=6281413082022"
            rel="noopener noreferrer"
          >
            <img src={icon.ICS} alt="" style={{ width: '16px' }} />
            <span className={classNames.cs}>PPPSRS</span>
          </a>
        </div>
      </div>

      <img
        src={icon.IWhatsapp}
        alt=""
        style={{
          width: xs ? '40px' : '40px',
          marginBottom: xs ? '-20px' : '20px',
        }}
        className={classNames.WAIcon}
      />
    </div>
  )
}

export default ContactMe
